import axios from '@/service/request';
import type { R } from './types';
import type { MiniLoginResponse } from './buyerWechatLogin';

/**
 * 手机号/邮箱密码登录请求参数
 */
export interface MiniLoginRequest {
  /** 手机国内号码或邮箱 */
  account?: string;
  /** 手机国际区号（如 +86），邮箱登录不传 */
  countryRegionCode?: string;
  /** 密码 */
  password?: string;
}

/**
 * 手机号/邮箱密码登录
 */
export const apiBuyerLoginPassword = (data: MiniLoginRequest): Promise<R<MiniLoginResponse>> => {
  return axios.post('/buyer/login/password', data, {
    toastError: false
  });
};

